'use strict';

if (!window.$) {
    // eslint-disable-next-line no-multi-assign
    window.jQuery = window.$ = require('jquery');
}

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./cleverReach/cleverReachSubscription'));
});
